import { generateSeoProps } from '../generateSeoProps';
export const getReviewsSeoProps = () => {
	return generateSeoProps({
		title: 'Pharmuni Reviews: What Learners Say About Our Pharma Courses',
		canonical: 'reviews',
		description:
			'Read verified learner reviews of Pharmuni pharma courses—GMP, pharmacovigilance, quality assurance, regulatory affairs & more—before choosing your next course.',
		noIndex: false
	});
};
